import { createFileRoute } from "@tanstack/react-router"
import { CompanyAvailabilityPage } from "@/features/companies/company-availability-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/availability")({
    component: CompanyAvailabilityPage,
})
